import {
  Button,
  Box,
  IconButton,
  Modal,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import DataTable from '../../../../components/table/datatable';
import { Close, HelpOutline } from '@mui/icons-material';
import { getColor } from '../../../../assets/theme';
import { GridColDef } from '@mui/x-data-grid';
import { memo, useEffect, useState } from 'react';
import { useGetProfileVisitHistoryQuery } from '../../../../api/front-office/profile.api.rtk';
import { VisitHistoryDetails } from '../../interface/fo-profile-interface';
import ServerError from '../../../../components/animation/server-error';

const DataTableColumns: GridColDef[] = [
  {
    field: 'bookingID',
    headerName: 'Booking ID',
    minWidth: 150,
    hideable: false,
    sortable: false,
  },
  {
    field: 'stayDuration',
    headerName: 'Stay Duration',
    minWidth: 150,
    hideable: false,
    sortable: false,
  },
  {
    field: 'resType',
    headerName: 'Type',
    minWidth: 120,
    hideable: false,
    sortable: false,
  },
  {
    field: 'ratePlan',
    headerName: 'Rate Plan',
    minWidth: 100,
    hideable: false,
    sortable: false,
  },
  {
    field: 'balance',
    headerName: 'Balance',
    minWidth: 120,
    hideable: false,
    sortable: false,
    align: 'right',
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 100,
    hideable: false,
    sortable: false,
  },
];

const ProfileVisitHistoryModal = ({
  isOpen,
  onClose,
  profileID,
}: {
  isOpen: boolean;
  onClose: () => void;
  profileID?: string | null | undefined;
}) => {
  const { primary, textGray } = getColor();
  const [visitHistoryData, setVisitHistoryDataTable] = useState<
    VisitHistoryDetails[]
  >([] as VisitHistoryDetails[]);

  const {
    data: profileVisitHistory,
    isError,
    isLoading,
  } = useGetProfileVisitHistoryQuery(`${profileID}`, {
    skip: !isOpen,
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (!profileVisitHistory?.data?.visits.length) return;

    console.log(profileVisitHistory);
    const visitHistoryDetails = profileVisitHistory.data.visits.map(
      (profileWrapper) => profileWrapper.visits,
    );

    console.log(visitHistoryDetails);
    setVisitHistoryDataTable(visitHistoryDetails);
  }, [isOpen, profileVisitHistory]);

  return (
    <Modal
      hideBackdrop={true}
      open={isOpen}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'rgba(0, 0, 0, 0.5)',
      }}
    >
      <Box
        sx={{
          p: '24px',
          position: 'fixed',
          transform: 'translate(0%, 0%)',
          minWidth: { xs: '90vw', md: '785px' },
          maxWidth: '90vw',
          height: 'auto',
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          boxShadow: 24,
          overflow: 'auto',
        }}
      >
        <Stack
          direction='row'
          justifyContent='space-between'
          borderBottom='1px solid #EEE'
          p='10px 0'
        >
          <Typography
            variant='h5'
            component='div'
            sx={{ flexGrow: 1, color: '#000000' }}
          >
            Visit History
            <Tooltip title='Learn More' placement='right-end'>
              <IconButton
                sx={{
                  border: 0,
                  color: textGray,
                  bgcolor: 'transparent',
                  ':hover': {
                    color: primary,
                    bgcolor: 'transparent',
                  },
                }}
                disableRipple
              >
                <HelpOutline />
              </IconButton>
            </Tooltip>
          </Typography>
          <IconButton color='inherit' onClick={onClose}>
            <Close />
          </IconButton>
        </Stack>
        <Box mb={1} />

        {isError ? (
          <ServerError />
        ) : (
          <DataTable
            getRowId={(row) => row.referenceID}
            columns={DataTableColumns}
            rows={visitHistoryData || []}
            loading={isLoading}
            disableColumnFilter
            disableColumnMenu
            disableColumnSelector
            pageSize={10}
            autoPageSize={false}
            checkboxSelection={false}
            tableStyle={{
              padding: 0,
              '&.MuiDataGrid-root': {
                p: 0,
              },
              '& .MuiTablePagination-root': {
                p: '0 10px',
              },
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: 'transparent',
                borderRadius: 0,
              },
              ".MuiButtonBase-root[aria-label='Export']": {
                display: 'none!important',
              },
              '.MuiDataGrid-root .MuiDataGrid-toolbar': {
                justifyContent: 'flex-start',
              },
            }}
            height={500}
          />
        )}

        <Stack
          direction='row'
          justifyContent='flex-end'
          borderBottom='1px solid #EEE'
        ></Stack>
        <Box mb={2} />
        <Stack direction='row' gap={1} justifyContent='flex-end'>
          <Box flexGrow={1} />
          <Button
            variant='outlined'
            sx={{
              width: '74px',
              height: '36px',
              border: '1px solid',
              backgroundColor: 'transparent',
            }}
            onClick={onClose}
          >
            Close
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default memo(ProfileVisitHistoryModal);
